import { get } from 'lodash'

/**
 * Flatten success responses body.
 *
 * @param response
 * @returns {*}
 */
export const success = response => get(response, 'data', {})

/**
 * Flatten error responses body.
 *
 * @param error
 * @returns {*}
 */
export const error = response => {
  const message = {
    data: get(response, 'response.data.data', {}),
    meta: get(response, 'response.data.meta', {})
  }

  return Promise.reject(message)
}

/**
 * Default export.
 */
export default {
  success,
  error
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors/flatten.js